// extracted by mini-css-extract-plugin
module.exports = {"criteria":"h_v","list":"h_w","results":"h_x","element":"h_y","shadow":"h_z"};